/**
 * ChatbotService - Service pour gérer les interactions avec le chatbot
 */
angular
  .module('chatbotModule')
  .service('ChatbotService', ChatbotService);

ChatbotService.$inject = ['$http'];

function ChatbotService($http) {
  // URL de l'API chatbot
  var API_URL = '';  // URL relative, le contexte de l'API est déjà configuré
  var service = {
    envoyerQuestion: envoyerQuestion,
    getQuestionsFrequentes: getQuestionsFrequentes
  };

  return service;

  /**
   * Envoie une question au serveur et retourne la réponse
   * @param {String} question - La question posée par l'utilisateur
   * @returns {Promise} - Promise contenant la réponse
   */
  function envoyerQuestion(question) {
    return $http.post(API_URL + '/api/api/chatbot/question', {
      question: question,
      timestamp: new Date().getTime()
    }).then(function(response) {
      return response.data;
    }).catch(function(error) {
      console.error('Erreur lors de l\'envoi de la question:', error);
      throw error;
    });
  }

  /**
   * Récupère la liste des questions fréquemment posées
   * @returns {Promise} - Promise contenant la liste des questions
   */
  function getQuestionsFrequentes() {
    return $http.get(API_URL + '/api/api/chatbot/questions-frequentes')
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error('Erreur lors de la récupération des questions fréquentes:', error);
        throw error;
      });
  }
}
